import * as types from "../../actions/actionTypes";
const initialState = {
  loading: true,
  error: "",
  selected: {},

  changeStateProcessing: false,

  meta: {},
  list: [],
  listLoading: false,
  listError: "",
  fetchedList: false,

  itemsObjectLoading: false,
  itemsObjectError: false,
  itemsObject: {},

  userListLoading: false,
  userListError: "",
  userList: [],

  trashedMeta: {},
  trashedList: [],
  trashedListLoading: false,
  trashedListError: ""
};

const ManagerPettyCash = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGER_GET_PETTY_CASH_REQUEST:
      return {
        ...state,
        selected: {},
        loading: true,
        error: ""
      };
    case types.MANAGER_GET_PETTY_CASH_SUCCESS:
      const { data, ...others } = action.payLoad;
      return {
        ...state,
        selected: { ...data, ...others },
        loading: false
      };
    case types.MANAGER_GET_PETTY_CASH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        selected: action.payLoad
      };

    case types.MANAGER_GET_PETTY_CASH_ITEMS_REQUEST:
      return {
        ...state,
        itemsObject: {},
        itemsObjectLoading: true,
        itemsObjectError: ""
      };
    case types.MANAGER_GET_PETTY_CASH_ITEMS_SUCCESS:
      return {
        ...state,
        itemsObject: action.payLoad,
        itemsObjectLoading: false
      };
    case types.MANAGER_GET_PETTY_CASH_ITEMS_FAILURE:
      return {
        ...state,
        itemsObjectLoading: false,
        itemsObjectError: action.error
      };

    case types.MANAGER_GET_LIST_PETTY_CASH_REQUEST:
      return {
        ...state,
        listLoading: true,
        list: [],
        meta: {},
        listError: "",
        fetchedList: false
      };
    case types.MANAGER_GET_LIST_PETTY_CASH_SUCCESS:
      return {
        ...state,
        list: action.payLoad.data,
        meta: action.payLoad.meta,
        listLoading: false,
        fetchedList: true
      };
    case types.MANAGER_GET_LIST_PETTY_CASH_FAILURE:
      return { ...state, listLoading: false, listError: action.error };
    case types.MANAGER_GET_TRASHED_SEQUENCE_REQUEST:
      return {
        ...state,
        trashedListLoading: true,
        trashedList: [],
        trashedMeta: {},
        trashedListError: "",
        fetchedList: false
      };
    case types.MANAGER_GET_TRASHED_SEQUENCE_SUCCESS:
      return {
        ...state,
        trashedList: action.payLoad.data,
        trashedMeta: action.payLoad.meta,
        trashedListLoading: false,
        fetchedList: true
      };
    case types.MANAGER_GET_TRASHED_SEQUENCE_FAILURE:
      return {
        ...state,
        trashedListLoading: false,
        trashedListError: action.error
      };
    case types.MANAGER_GET_NUMBER_LIST_PETTY_CASH_REQUEST:
      return {
        ...state,
        listLoading: true,
        list: [],
        meta: {},
        listError: "",
        fetchedList: false
      };
    case types.MANAGER_GET_NUMBER_LIST_PETTY_CASH_SUCCESS:
      return {
        ...state,
        list: action.payLoad.data,
        meta: action.payLoad.meta,
        listLoading: false,
        fetchedList: true
      };
    case types.MANAGER_GET_NUMBER_LIST_PETTY_CASH_FAILURE:
      return { ...state, listLoading: false, listError: action.error };

    case types.MANAGER_CHANGE_STATE_PETTY_CASH_REQUEST:
      return { ...state, changeStateProcessing: true };
    case types.MANAGER_CHANGE_STATE_PETTY_CASH_SUCCESS:
      const { data: _data, ..._others } = action.payLoad;
      return {
        ...state,
        selected: { ..._data, ..._others },
        changeStateProcessing: false
      };
    case types.MANAGER_CHANGE_STATE_PETTY_CASH_FAILURE:
      return {
        ...state,
        changeStateProcessing: false
      };

    case types.UNDER_MANAGER_CONTROL_USERS_LIST_REQUEST:
      return {
        ...state,
        userListLoading: true,
        userListError: false
      };
    case types.UNDER_MANAGER_CONTROL_USERS_LIST_SUCCESS:
      return {
        ...state,
        userListLoading: false,
        userList: action.payLoad
      };
    case types.UNDER_MANAGER_CONTROL_USERS_LIST_FAILURE:
      return {
        ...state,
        userListLoading: false,
        userListError: true
      };

    default:
      return state;
  }
};

export default ManagerPettyCash;
